"use client";

import React from "react";
import { ArrowRight, Cpu, Hammer, Activity, Wrench } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Odszkodowania z OC sprawcy",
  description: "Prowadzimy sprawy o odszkodowanie wynikające z odpowiedzialności cywilnej sprawcy. Analizujemy dokumentację, podstawy prawne roszczeń i reprezentujemy klientów w Słupsku.",
  icon: Activity,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1539347/img/cad_design_station.png",
  link: "/ServicesPage"
}, {
  title: "Wypadki komunikacyjne",
  description: "Reprezentujemy osoby poszkodowane w wypadkach drogowych, w tym kierowców i pieszych. Oceniamy odpowiedzialność cywilną sprawcy i dochodzimy należnych świadczeń z polisy OC.",
  icon: Cpu,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1539347/img/cnc_machining_tools.png",
  link: "/ServicesPage"
}, {
  title: "Wypadki przy pracy i rolnicze",
  description: "Pomagamy w dochodzeniu roszczeń wynikających z odniesionych obrażeń w pracy i gospodarstwach rolnych. Analizujemy odpowiedzialność pracodawcy oraz świadczenia z KRUS.",
  icon: Hammer,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1539347/img/robotic_arm_assembly.png",
  link: "/ServicesPage"
}, {
  title: "Zadośćuczynienia i błędy",
  description: "Pomagamy w sprawach o zadośćuczynienie pieniężne za ból i cierpienie oraz w przypadkach błędów medycznych. Zapewniamy rzetelną opinię prawną i reprezentację procesową.",
  icon: Wrench,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1539347/img/steel_structure_welding.png",
  link: "/ServicesPage"
}];
export default function ServicesGrid() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="179139" id="odszkodowaniasłupsk" className="bg-background py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8">
        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {services.map((service, i) => <div key={i} data-index={i} className="relative flex flex-col p-8 min-h-[480px] overflow-hidden group rounded-md border border-primary/10 bg-white shadow-soft hover:shadow-strong transition-all duration-300">
              {}
              <img src={service.image} alt="" className="absolute inset-0 w-full h-full object-cover z-0 opacity-10 grayscale mix-blend-multiply transition-transform duration-700 group-hover:scale-110" aria-hidden="true" />
              <div className="absolute inset-0 z-0 bg-gradient-to-b from-white/40 via-white/80 to-white" />

              {}
              <div className="relative z-10 flex flex-col h-full">
                {}
                <div className="w-16 h-16 rounded-md border-2 border-primary flex items-center justify-center mb-8 bg-primary-light backdrop-blur-sm shadow-sm transition-colors group-hover:bg-primary group-hover:border-primary">
                  <service.icon className="w-8 h-8 text-primary group-hover:text-white transition-colors" />
                </div>

                {}
                <div className="mt-auto flex flex-col gap-5">
                  <h3 className="text-2xl font-display font-bold uppercase tracking-tight text-primary leading-tight">
                    {service.title}
                  </h3>
                  <p className="text-muted-foreground font-serif leading-relaxed text-sm md:text-base">
                    {service.description}
                  </p>
                  
                  <div className="pt-4 mt-auto">
                    <Button asChild variant="default" className="rounded-md bg-secondary hover:bg-secondary-hover text-white uppercase font-sans font-bold tracking-wider group/btn w-full sm:w-auto shadow-sm transition-all duration-200">
                      <Link to={service.link}>
                        Analiza sprawy
                        <ArrowRight className="w-4 h-4 ml-2 transition-transform duration-300 group-hover/btn:translate-x-1" />
                      </Link>
                    </Button>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}